<template>
  <div class="b-settings__block p-6 pb-8 mt-6">
    <h2 class="mb-4">
      {{ $t('CONTENT.settingsPage.closed_period_settings') }}
    </h2>
    <div class="row mt-5">
      <div class="col-12">
        <div
          v-if="settingsIsLoading"
          class="b-form__container"
        >
          <label>{{ $t('CONTENT.settingsPage.last_closed_period') }}:</label> {{ LastClosePeriodDate }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form
          v-if="isLoaded"
          class="b-form p-0"
          @submit.prevent="onSubmitClose"
        >
          <div class="row mt-5">
            <div class="col-12">
              <label>{{ $t('CONTENT.settingsPage.close_period') }}:</label>
            </div>
          </div>
          <div class="row b-form__row_type_flex-end mt-1">
            <div class="col-5">
              <cool-select
                :isDisabled="isReadOnlyMode"
                v-model="SelectedId"
                :list="Months"
                option-value="id"
                option-text="value"
              />
            </div>
            <div class="col-7">
              <numeric
                :disabled="isReadOnlyMode"
                v-model="formData.year"
                class="b-numeric"
                controls
                :min="2000"
                :max="3000"
                @keypress="changeNumericValue($event)"
              />
            </div>
          </div>
          <button
            v-if="!isReadOnlyMode"
            class="b-btn b-btn_type_primary mt-4"
            type="submit"
            :disabled="isDisabledCloseBtn"
          >
            Закрыть период
          </button>
        </form>
      </div>
      <div class="col-6">
        <form
          v-if="isLoaded && ClosedPeriods"
          class="b-form p-0"
          @submit.prevent="onSubmitOpen"
        >
          <div class="row mt-5">
            <div class="col-12">
              <label>{{ $t('CONTENT.settingsPage.open_closed_period') }}:</label>
            </div>
          </div>
          <div class="row b-form__row_type_flex-end mt-1">
            <div class="col-12">
              <cool-select
                :isDisabled="isReadOnlyMode"
                v-model="closedPeriodForOpen"
                :list="ClosedPeriods"
                option-value="id"
                option-text="value"
              />
            </div>
          </div>
          <button
            v-if="!isReadOnlyMode"
            class="b-btn b-btn_type_primary mt-4"
            type="submit"
            :disabled="isDisabledOpenBtn"
          >
            Открыть период
          </button>
        </form>
      </div>
    </div>

    <popup name="close-period-success" height="auto">
      <notification-popup :title="$t('CONTENT.settingsPage.close_period_success_title')" :message="$t('CONTENT.settingsPage.close_period_success_message')" @onClose="closeModals"/>
    </popup>
    <popup name="close-period-error" height="auto">
      <notification-popup type="error" :title="$t('CONTENT.settingsPage.close_period_error')" :message="errorMessage"  @onClose="closeModals"/>
    </popup>
    <popup name="open-period-success" height="auto">
      <notification-popup :title="$t('CONTENT.settingsPage.open_period_success_title')" :message="$t('CONTENT.settingsPage.open_period_success_message')" @onClose="closeModals"/>
    </popup>
    <popup name="open-period-error" height="auto">
      <notification-popup type="error" :title="$t('CONTENT.settingsPage.open_period_error')" :message="errorMessage"  @onClose="closeModals"/>
    </popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import changeNumericValue from '../../mixins/changeNumericValue';
import ReportsAPI from '@/plugins/reports/api/ReportsAPI';
import SystemSettingsAPI from '../../api/SystemSettingsAPI';
import NotificationPopup from '../NotificationPopup';
import DateConverter from '../../utils/converters/date.converter';
import { i18n } from '../../plugins/vue-i18n';

export default {
  name: 'ClosedPeriodSettings',
  components: {NotificationPopup},

  mixins: [changeNumericValue],
  props: {
    isReadOnlyMode: {
      type: Boolean
    },
  },
  data() {
    return {
      isDisabledCloseBtn: true,
      isDisabledOpenBtn: true,
      settings: null,
      settingsIsLoading: false,
      formData: {
        selectedId: null,
        year: null,
        lastClosedPeriod: null,
        closedPeriodForOpen: null,
      },
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
    Months: {
      get() {
        if (this.settings === null) {
          this.settings = this.getContractSettings;
          this.settingsIsLoading = true;
        }
        return [
          { id: '1', value: 'Январь' },
          { id: '2', value: 'Февраль' },
          { id: '3', value: 'Март' },
          { id: '4', value: 'Апрель' },
          { id: '5', value: 'Май' },
          { id: '6', value: 'Июнь' },
          { id: '7', value: 'Июль' },
          { id: '8', value: 'Август' },
          { id: '9', value: 'Сентябрь' },
          { id: '10', value: 'Октябрь' },
          { id: '11', value: 'Ноябрь' },
          { id: '12', value: 'Декабрь' },
        ];
      },
    },
    ClosedPeriods: {
      get() {
        if (this.settings === null) {
          this.settings = this.getContractSettings;
          this.settingsIsLoading = true;
        }
        if (!this.settings.closedPeriods.length) {
          return null;
        }
        const result = [];
        for (let period of this.settings.closedPeriods) {
          const date = DateConverter.convertToDate(period);
          result.push({id: period, value: this.Months[date.getMonth()].value + " " + date.getFullYear()})
        }
        return result;
      },
    },
    closedPeriodForOpen: {
      get() {
        return this.formData.closedPeriodForOpen;
      },
      set(newVal) {
        this.formData.closedPeriodForOpen = newVal;
        this.isDisabledOpenBtn = false;
      },
    },
    SelectedId: {
      get() {
        return this.formData.lastClosedPeriod;
      },
      set(newVal) {
        this.formData.lastClosedPeriod = newVal;
        this.isDisabledCloseBtn = false;
      },
    },
    LastClosePeriodDate: {
      get() {
        if (this.settings.lastClosePeriodDate === '') return '-'
        const date = DateConverter.convertToDate(this.settings.lastClosePeriodDate);
        return this.Months[date.getMonth()].value + " " + date.getFullYear();
      },
    },
  },
  methods: {
    async onSubmitClose() {
      try {
        this.$loadingManager.addLoadingStep()
        const api = new SystemSettingsAPI()

        await api.closePeriod({
          Month: this.formData.lastClosedPeriod,
          Year: this.formData.year,
        })

        this.settings = await new SystemSettingsAPI().getContractSettings()
        this.isDisabledCloseBtn = true
        this.$loadingManager.loadingStepLoaded()
        this.$modal.show('close-period-success')
      } catch (e) {
        const exceptions = e.response.data.exceptions
        if (exceptions !== null) this.errorMessage = exceptions[0].message
        this.$modal.show('close-period-error')
        this.$loadingManager.hideLoadScreen()
      }
    },
    async onSubmitOpen() {
      try {
        this.$loadingManager.addLoadingStep()
        const api = new SystemSettingsAPI()
        const closeDateForOpen = DateConverter.convertToDate(this.formData.closedPeriodForOpen)


        await api.openPeriod({
          Month: closeDateForOpen.getMonth()+1,
          Year: closeDateForOpen.getFullYear(),
        })

        this.settings = await new SystemSettingsAPI().getContractSettings()
        this.isDisabledOpenBtn = true
        this.$loadingManager.loadingStepLoaded()
        this.$modal.show('open-period-success')
      } catch (e) {
        const exceptions = e.response.data.exceptions
        if (exceptions !== null) this.errorMessage = exceptions[0].message
        this.$modal.show('open-period-error')
        this.$loadingManager.hideLoadScreen()
      }
    },
    closeModals() {
      this.$modal.hide('close-period-success')
      this.$modal.hide('close-period-error')
      this.$modal.hide('open-period-success')
      this.$modal.hide('open-period-error')
    }
  },
};
</script>
